import React from 'react';
import PropTypes from 'prop-types';
import Context from './Context';
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();

const Provider = (props) => {
  if (!props.appId) {
    throw new Error("Missing appId from @ls/persistence-module <Provider/>");
  }

  return (
    <QueryClientProvider client={queryClient}>
      <Context.Provider value={props}>
        {props.children}
      </Context.Provider>
    </QueryClientProvider>
  );
};

Provider.propTypes = {
  baseURL: PropTypes.string,
  appId: PropTypes.string.isRequired,
};

Provider.defaultProps = {
  baseURL: 'http://ace/prd/imt/settingsservice', 
};

export default Provider;
